<template>
    <system-tabs :tabs="tabs">
        <template slot="help">
            <helpTable/>
            <helpDocument/>
        </template>

        <template slot="w1">
            <InterfaceDocument v-model="content" disabled>
                <div class="task__textarea-wrapper">
                    <v-alert
                            outline
                            color="warning"
                            v-model="alert"
                            dismissible
                            class="task__textarea-help"
                    >
                        Нам нужны фамилии и имена людей, которые могут участвовать в конкурсе. Скопируйте их из таблицы сюда. Каждое новое имя из таблицы располагайте на новой строке. Спасибо!
                    </v-alert>
                    <textarea class="task__textarea" v-model="result"></textarea>
                </div>
                <div class="my-menu">
                    <div class="my-menu__drop mce-container mce-panel mce-floatpanel mce-menu mce-animate mce-menu-has-icons mce-menu-align mce-in">
                        <div class="mce-container-body mce-stack-layout">
                            <div class="mce-menu-item mce-menu-item-expand mce-menu-item-normal mce-stack-layout-item mce-first" @click="onSave">
                                <span class="mce-text">Сохранить</span>
                            </div>
                        </div>
                    </div>
                </div>
            </InterfaceDocument>

            <v-dialog v-model="dialog" width="500">
                <v-card>
                    <v-card-text>Данные успешно сохранены!</v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" flat @click="dialog = false">Закрыть</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </template>

        <template slot="w2">
            <InterfaceTable :headers="table.headers" :data="table.data" with-index/>
        </template>
    </system-tabs>
</template>

<script>
    import InterfaceTable from '@/components/interface/table'
    import InterfaceDocument from '@/components/interface/document'
    import SystemTabs from '@/components/system/tabs'

    import helpDocument from '@/components/interface/document/help'
    import helpTable from '@/components/interface/table/help'

    import data from './_data.json'

    export default {
        components: {
            InterfaceTable,
            SystemTabs,
            InterfaceDocument,
            helpDocument,
            helpTable
        },
        data () {
            return {
                content: data.document,
                result: '',
                dialog: false,
                alert: true,
                actions: {
                    count: 0
                },
                tabs: [
                    {
                        title: 'Текстовый редактор',
                        name: 'doc',
                        slot: 'w1'
                    },
                    {
                        title: 'Клиентская база',
                        name: 'table',
                        slot: 'w2'
                    }
                ],
                table: data.table
            }
        },
        methods: {
            onSave () {
                this.dialog = true
                let count = 0
                if (this.result.search(/Копылов Дарий/i) > -1) {
                    count++
                }
                if (this.result.search(/Одинцова Мария/i) > -1) {
                    count++
                }
                if (this.result.search(/Быкова Надежда/i) > -1) {
                    count++
                }
                if (this.result.search(/Вишнякова Искра/i) > -1) {
                    count++
                }
                if (this.result.search(/Гаврилова Василиса/i) > -1) {
                    count++
                }
                this.actions.count = count
                this.$store.dispatch('questions/answer', this.actions)
            },

            // Завершение теста
            // Выполнение необходимых действий перед
            // переходом к следующему заданию / этипу
            finish () {}
        }
    }
</script>

<style lang="stylus" scoped>
    .task__textarea {
        width 100%
        height 100%
        resize none

        &-wrapper {
            position absolute
            top 140px
            left 20px
            width 47%
            height 200px!important
            resize none
            text-align center
        }

        &-help,
        &-help2 {
            top 25%
            left 70%
            width 17rem
            background #fff
            position absolute
            z-index 10
            font-size 13px
            line-height normal
            margin 0
            padding 6px 6px 6px 8px

            /deep/ .alert__dismissible {
                margin 0
            }

            &::before {
                top 50%
                transform translateY(-10px)
                content ''
                display block
                position absolute
                right 100%
                border 10px solid transparent
                border-right-color #ffc107
            }
        }

        &-help2 {
            left: 75px
            top: 8px

            &::before {
                top -1px
                transform none
            }
        }
    }

    .my-menu {
        position absolute
        top 0
        left 0
        display block
        width 67px
        cursor pointer
        height 35px

        &:hover &__drop {
            display block
        }
        &__drop {
            display none
            top 100%
        }
    }
</style>
